import {initElements} from '../define/shared'

export default function initFormBlocks() {
    initElements('.wab.wab-form', initFormBlock)
}

/**
 * @param {HTMLElement} root
 */
export function initFormBlock(root) {
    const wpcf7 = root.querySelector('.wpcf7'),
        link = root.querySelector('.downloadLink')

    if (!link) {
        return
    }

    wpcf7.addEventListener('wpcf7mailsent', () => {
        link.click()
    })
}
